import { useQuery } from '@tanstack/react-query';
import { getSettings } from '../lib/api';
import { AiWorkingIndicator } from './AiWorkingIndicator';

/**
 * The app-wide busy indicator. Renders the user's configured "Working animation"
 * (Settings → Working animation) at a given pixel size — a drop-in replacement
 * for the old `.spinner`. It reads the setting itself, so call sites are just
 * `<WorkingSpinner size={12} />`. Falls back to the default variant until the
 * settings query resolves.
 */
export function WorkingSpinner({ size = 18, title = 'Working…' }: { size?: number; title?: string }) {
  const { data: settings } = useQuery({ queryKey: ['settings'], queryFn: getSettings, staleTime: 60_000 });
  const variant = settings?.aiWorkingAnimation ?? 'constellation';
  const scale = size / 18; // .aiw-box renders at 18px; scale to the requested size

  return (
    <span
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: size, height: size, flexShrink: 0, verticalAlign: 'middle',
      }}
    >
      <span style={{ display: 'inline-flex', transform: scale === 1 ? undefined : `scale(${scale})`, transformOrigin: 'center' }}>
        <AiWorkingIndicator active variant={variant} title={title} />
      </span>
    </span>
  );
}
